import { c as _c } from "react/compiler-runtime";
import type React from 'react';
type LineItemProps = {
  label: string;
  value?: string;
  badge?: React.ReactNode;
  customValue?: React.ReactNode;
};
const LineItem = t0 => {
  const $ = _c(11);
  const {
    label,
    value,
    badge,
    customValue
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <p className="text-body-2 text-tertiary">{label}</p>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== badge || $[3] !== t1) {
    t2 = <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">{t1}{badge}</div>;
    $[2] = badge;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== customValue || $[6] !== value) {
    t3 = customValue ?? <p className="max-w-[60%] shrink-0 text-right text-body-2 text-primary wrap-anywhere">{value}</p>;
    $[5] = customValue;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex w-full items-center justify-between gap-6">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default LineItem;